import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import collegeLogo from '../image/np1747740820_247d415195ee7b3d1dea-removebg-preview.png';
import emailIcon from '../image/emailnew.svg';
import '../css/Header.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header">
      <div className="top-bar">
        <div className="container-Header">
          <div className="college-info">
            
              <img src={collegeLogo} alt="S.N. Sinha College" className="college-logo" />
  
          </div>
          <div className="contact-info">
            <div className="contact-item">
              <img src={emailIcon} alt="Email" className="contact-icon" />
              <span>snscwrs@gmail.com</span>
            </div>
            
          </div>
        </div>
      </div>
      
      <nav className="navbar">
        <div className="container">
          <div className="nav-brand">
            <button className="menu-toggle" onClick={toggleMenu}>
              ☰
            </button>
          </div>
          
          <ul className={`nav-links ${isOpen ? 'open' : ''}`}>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/administration">Administration</Link></li>
            <li><Link to="/department">Department</Link></li>
            <li><Link to="/staff">Staff</Link></li>
            <li><Link to="/downloads">Downloads</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/examination">Examination</Link></li>
            <li><Link to="/alumni">Alumni</Link></li>
            <li><Link to="/student-corner">Student Corner</Link></li>
            <li><Link to="/library">Library</Link></li>
            <li><Link to="/admission">Online Admission</Link></li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Header;